import React, { useEffect } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { routePaths } from '../../urls'
import { checkBrightspaceConfiguration } from '../../actions'
import { useStateValue } from '@State'
import { MissingAKPMessage } from './MissingAKPMessage'
import { BrightspaceSetup } from './Setup'
import { Assessments } from './Assessments'
import { BrightspaceTest } from './Test'

export const Brightspace = () => {
  const [state, dispatch] = useStateValue()

  useEffect(() => {
    if (state.brightspaceAKPConfigured === undefined) {
      checkBrightspaceConfiguration(dispatch)
    }
  }, [])

  if (state.brightspaceAKPConfigured === undefined) {
    return null
  }
  if (state.brightspaceAKPConfigured === false) {
    return <MissingAKPMessage />
  }

  return (
    <div>
      <Route path={routePaths.brightspaceSetup} component={BrightspaceSetup} />
      <Route path={routePaths.brightspaceAssessments} component={Assessments} />
      <Route path={routePaths.brightspaceTest} component={BrightspaceTest} />
      <Route
        exact
        path={routePaths.brightspace}
        render={() => <Redirect to={routePaths.brightspaceSetup} />}
      />
    </div>
  )
}


